export default __webpack_public_path__ + "static/media/arrows-vertical.a43e2246.svg";